<template>
  <div style="height:100%">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  data () {
    return {

    }
  }
}
</script>
<style lang="scss" scope>
  @import './form.scss';
</style>
